function noop() {
  return {};
}

module.exports = noop;
